import {Component, OnDestroy, OnInit} from '@angular/core';

import {RegistryService} from "../../../../../services/registry.service";
import {AuthService} from "../../../../../../../services/auth.service";
import {PaymentService} from "../../../../../services/payment.service";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-knet-order-failed',
    templateUrl: './knet-order-failed.component.html',
    styleUrls: ['./knet-order-failed.component.css']
})
export class KnetOrderFailedComponent implements OnInit, OnDestroy {

    userLoggedOutEvent;
    orderId = null;

    payment_button_visibility = false;

    order_id="";
    transaction_id="";
    txn_type="";
    method="";
    txn_id="";
    created_at="";

    constructor(public registry: RegistryService,
                private authService: AuthService,
                private paymentService: PaymentService,
                private route: ActivatedRoute
    ) {

    }

    ngOnInit(): void {


        this.route.queryParams.subscribe(paramMap => {

            this.order_id = paramMap.orderid;
            this.transaction_id = paramMap.transaction_id;
            this.txn_type = paramMap.txn_type;
            this.method = paramMap.method;
            this.txn_id = paramMap.txn_id;
            this.created_at = paramMap.created_at;


        })


    }

    ngOnDestroy(): void {
    }

}
